.skeleton {
  display: block;
  background: linear-gradient(90deg, var(--skeleton) 0%, var(--skeleton-highlight) 50%, var(--skeleton) 100%);
  background-size: 200% 100%;
  border-radius: var(--radius-small);
  animation: shimmer 1.2s linear infinite;
}

.line {
  block-size: 12px;
}

.title {
  block-size: 20px;
}

.block {
  block-size: 96px;
  border-radius: var(--radius-card);
}

.thumb {
  aspect-ratio: 16 / 10;
  border-radius: var(--radius-card);
}

.circle {
  inline-size: 24px;
  block-size: 24px;
  border-radius: 50%;
}

.full {
  inline-size: 100%;
}

.threeQuarters {
  inline-size: 75%;
}

.half {
  inline-size: 50%;
}

.third {
  inline-size: 33%;
}

.circle.full,
.circle.threeQuarters,
.circle.half,
.circle.third {
  inline-size: 24px;
}

@keyframes shimmer {
  from {
    background-position: 200% 0;
  }

  to {
    background-position: -200% 0;
  }
}

@media (prefers-reduced-motion: reduce) {
  .skeleton {
    animation: none;
  }
}
